import 'keen-slider/keen-slider.min.css'

import { useKeenSlider } from 'keen-slider/react'
import { useState } from 'react'

import { solarEnergy } from './utils/solar-energy-cards-data'
import { Dots } from './dots'
import { Card } from './card'

export const SolarEnergyCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0)
  const [loaded, setLoaded] = useState<boolean>(false)

  const [sliderRef, instanceRef] = useKeenSlider<HTMLDivElement>({
    initial: 0,
    slides: {
      perView: 1,
      spacing: 16,
      origin: 'center'
    },
    loop: true,
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
    },
    created() {
      setLoaded(true)
    }
  })

  return (
    <div className="relative md:hidden flex items-center justify-center mt-4 mb-16">
      <div ref={sliderRef} className="keen-slider py-10">
        {solarEnergy.map((item, index) => {
          return (
            <div
              key={index}
              className="keen-slider__slide grid justify-center px-[26px] pb-[29px]"
            >
              <div className="pt-4 pb-[29px] px-[26px] shadow-xl rounded-lg w-[336px] h-[250px] bg-white">
                <Card
                  key={item.title}
                  icon={item.icon}
                  title={item.title}
                  content={item.content}
                  bulletItems={item.bulletItems}
                />
              </div>
            </div>
          )
        })}
      </div>

      {loaded && (
        <div className="absolute -bottom-4 lg:hidden">
          <Dots
            dotsQuantity={instanceRef.current?.track?.details?.slides.length}
            onMoveToSlide={instanceRef.current?.moveToIdx}
            currentSlide={currentSlide}
          />
        </div>
      )}
    </div>
  )
}
